import { render, staticRenderFns } from "./FilterMenu.vue?vue&type=template&id=c2976880&scoped=true"
import script from "./FilterMenu.vue?vue&type=script&lang=js"
export * from "./FilterMenu.vue?vue&type=script&lang=js"
import style0 from "./FilterMenu.vue?vue&type=style&index=0&id=c2976880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2976880",
  null
  
)

export default component.exports